var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStartups(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_357_1975)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.73996 17.3799V3.16006C4.73996 2.74103 4.90642 2.33915 5.20273 2.04285C5.49903 1.74654 5.90091 1.58008 6.31995 1.58008H12.6399C13.0589 1.58008 13.4608 1.74654 13.7571 2.04285C14.0534 2.33915 14.2199 2.74103 14.2199 3.16006V17.3799H4.73996Z",
    stroke: "#364153",
    strokeWidth: 1.57999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.73994 9.48047H3.15996C2.74092 9.48047 2.33904 9.64693 2.04274 9.94324C1.74643 10.2395 1.57997 10.6414 1.57997 11.0605V15.8004C1.57997 16.2195 1.74643 16.6213 2.04274 16.9176C2.33904 17.2139 2.74092 17.3804 3.15996 17.3804H4.73994",
    stroke: "#364153",
    strokeWidth: 1.57999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2199 7.11035H15.7999C16.2189 7.11035 16.6208 7.27681 16.9171 7.57312C17.2134 7.86942 17.3799 8.2713 17.3799 8.69034V15.8003C17.3799 16.2193 17.2134 16.6212 16.9171 16.9175C16.6208 17.2138 16.2189 17.3803 15.7999 17.3803H14.2199",
    stroke: "#364153",
    strokeWidth: 1.57999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.89995 4.74023H11.0599",
    stroke: "#364153",
    strokeWidth: 1.57999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.89995 7.90137H11.0599",
    stroke: "#364153",
    strokeWidth: 1.57999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.89995 11.0596H11.0599",
    stroke: "#364153",
    strokeWidth: 1.57999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.89995 14.2207H11.0599",
    stroke: "#364153",
    strokeWidth: 1.57999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_357_1975"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.9598,
    height: 18.9598,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartups);
export default __webpack_public_path__ + "static/media/startups.35d51508a76e1ef50d6b6dd5c2f443e7.svg";
export { ForwardRef as ReactComponent };